module.exports = __webpack_public_path__ + "static/media/phone.0e1b4642.svg";